import FreebusyStore, { FreebusySettings } from '.';
import { Freebusy } from '../components/Freebusy/Types';

export function successfulLoading(
  freebusySettings: FreebusySettings,
  freebusyStore: FreebusyStore,
  freebusy: Freebusy,
): void;
export function successfulLoading(
  freebusySettings: FreebusySettings,
  freebusyStore: FreebusyStore,
): (freebusy: Freebusy) => void;
export function successfulLoading(
  freebusySettings: FreebusySettings,
  freebusyStore: FreebusyStore,
  freebusy?: Freebusy,
) {
  const doit = (freebusy: Freebusy) => freebusyStore.initializing(freebusy, freebusySettings);

  return typeof freebusy === 'undefined' ? doit : doit(freebusy);
}
